(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cz-racket-quiz"] && !Shopify.designMode) return;
  try {
    
  class CzRacketQuiz extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-quiz-form]');
      this.steps = [...this.querySelectorAll('.cz-quiz__step')];
      this.bars = [...this.querySelectorAll('.cz-quiz__progress-bar span')];
      this.next = this.querySelector('[data-next]');
      this.nextLabel = this.querySelector('[data-next-label]');
      this.back = this.querySelector('[data-back]');
      this.counter = this.querySelector('[data-step-counter]');
      this.stepTitle = this.querySelector('[data-step-title]');
      this.soon = this.querySelector('[data-soon]');
      this.result = this.querySelector('[data-result]');
      this.stepsWrap = this.querySelector('.cz-quiz__steps');
      this.texts = JSON.parse(this.querySelector('[data-quiz-texts]').textContent);
      this.index = 0;

      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.forward();
      });
      this.back.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-restart]').addEventListener('click', () => this.restart());
      this.show(0);
    }

    value(name) {
      return this.form.querySelector(`input[name="${name}"]:checked`)?.value || null;
    }

    show(index) {
      this.index = Math.max(0, Math.min(index, this.steps.length - 1));
      this.steps.forEach((step, i) => (step.hidden = i !== this.index));
      this.bars.forEach((bar, i) => {
        bar.classList.toggle('is-done', i < this.index);
        bar.classList.toggle('is-current', i === this.index);
      });
      const step = this.steps[this.index];
      this.counter.textContent = this.texts.stepLabel.replace('[n]', this.index + 1);
      this.stepTitle.textContent = step.dataset.title;
      this.back.disabled = this.index === 0;
      this.nextLabel.textContent = this.index === this.steps.length - 1 ? this.texts.finishLabel : this.texts.nextLabel;
      this.update();
    }

    update() {
      const name = this.steps[this.index].dataset.step;
      const picked = this.value(name);
      const tennisBlocked = name === 'sport' && picked === 'tennis' && this.dataset.tennisAvailable !== 'true';
      this.soon.hidden = !tennisBlocked;
      this.next.disabled = !picked || tennisBlocked;
    }

    forward() {
      if (this.next.disabled) return;
      if (this.index < this.steps.length - 1) {
        this.show(this.index + 1);
        this.steps[this.index].querySelector('input:not(:disabled)')?.focus();
      } else {
        this.finish();
      }
    }

    inBudget(price, budget) {
      const b1 = Number(this.dataset.budgetLow);
      const b2 = Number(this.dataset.budgetHigh);
      if (budget === 'low') return price <= b1;
      if (budget === 'mid') return price > b1 && price <= b2;
      return price > b2;
    }

    finish() {
      const level = this.value('level');
      const style = this.value('style');
      const budget = this.value('budget');
      const order = ['Початківець', 'Аматор', 'Профі'];
      const template = this.querySelector('[data-candidates]');
      const cards = [...template.content.querySelectorAll('.cz-quiz-card')];

      const scored = cards
        .map((card) => {
          const d = card.dataset;
          const price = Number(d.price);
          let score = 0;
          const reasons = [];
          if (d.level === level) {
            score += 4;
            reasons.push(this.texts.whyLevel.replace('[level]', level.toLowerCase()));
          } else if (d.level && Math.abs(order.indexOf(d.level) - order.indexOf(level)) === 1) {
            score += 1;
          }
          if (d.style === style) {
            score += 4;
            reasons.push(this.texts.whyStyle.replace('[style]', style.toLowerCase()));
          }
          if (this.inBudget(price, budget)) {
            score += 3;
            reasons.push(this.texts.whyBudget);
          }
          if (d.shape) {
            reasons.push(
              this.texts.whyShape
                .replace('[shape]', d.shape.toLowerCase())
                .replace('[balance]', (d.balance || '—').toLowerCase())
            );
          }
          // in-stock rackets always rank above sold-out ones
          if (d.available === 'true') score += 20;
          return { card, score, price, reasons };
        })
        .sort((a, b) => b.score - a.score || a.price - b.price)
        .slice(0, 3);

      const list = this.querySelector('[data-cards]');
      list.replaceChildren();
      scored.forEach((item, i) => {
        const card = item.card.cloneNode(true);
        card.querySelector('[data-tag]').textContent = (this.texts.tags[i] || '').trim();
        const why = item.reasons.length ? item.reasons.join(' ') : this.texts.whyFallback;
        card.querySelector('[data-why]').textContent = why;
        list.append(card);
      });
      this.querySelector('[data-empty]').hidden = scored.length > 0;

      this.showGift(scored[0]?.price);

      this.querySelector('[data-summary]').textContent = this.texts.summary
        .replace('[level]', level)
        .replace('[style]', style)
        .replace('[budget]', this.texts.budgetLabels[budget] || '');

      this.stepsWrap.hidden = true;
      this.result.hidden = false;
      this.result.focus({ preventScroll: true });
      this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /** The largest denomination that still fits under the top pick, so the gift covers most of it. */
    showGift(topPrice) {
      const wanted = this.form.querySelector('input[name="gift"]')?.checked;
      const tradeIn = this.querySelector('[data-tradein]');
      if (tradeIn) tradeIn.hidden = Boolean(wanted);
      const box = this.querySelector('[data-gift]');
      if (!box) return;
      const cards = this.texts.giftCards || [];
      box.hidden = !wanted || cards.length === 0;
      if (box.hidden) return;
      const sorted = [...cards].sort((a, b) => a.price - b.price);
      const card = [...sorted].reverse().find((c) => !topPrice || c.price <= topPrice) || sorted[0];
      box.querySelector('[data-gift-text]').textContent = this.texts.giftText.replace('[amount]', card.amount);
      box.querySelector('[data-gift-link]').href = card.url;
      const image = box.querySelector('[data-gift-image]');
      if (card.image) {
        image.src = card.image;
        image.alt = card.amount;
      }
      image.hidden = !card.image;
    }

    restart() {
      this.form.reset();
      this.result.hidden = true;
      this.stepsWrap.hidden = false;
      this.show(0);
      this.stepsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!customElements.get('cz-racket-quiz')) {
    customElements.define('cz-racket-quiz', CzRacketQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
